import { handleActions, combineActions } from 'redux-actions'
import { fromJS, isImmutable } from 'immutable'

import * as AppActions from 'actions/app'
import * as Actions from 'actions/journalists'

export const initialState = fromJS({
  distributionLists: {
    items: [],
    total: 0
  },
  contentBasedSearch: {
    contents: [],
    total: 0
  },
  journalists: {
    items: [],
    ids: [],
    total: 0
  },
  myContacts: {
    items: [],
    ids: [],
    total: 0
  },
  jobTitles: [],
  publications: [],
  news: {
    items: [],
    total: 0
  }
})

export default handleActions({
  [Actions.fetchContentBasedSearchContentsSuccess]: (state, { payload }) => state
    .setIn(['contentBasedSearch', 'contents'], fromJS(payload.contents))
    .setIn(['contentBasedSearch', 'total'], payload.total),

  [Actions.searchDistributionListsSuccess]: (state, { payload }) => state
    .setIn(['distributionLists', 'items'], fromJS(payload.distributionLists))
    .setIn(['distributionLists', 'total'], payload.total),

  [Actions.searchJournalistsSuccess]: (state, { payload }) => {
    let newState = state

    if (payload.allContacts) {
      newState = newState
        .setIn(['journalists', 'items'], fromJS(payload.allContacts.contacts))
        .setIn(['journalists', 'total'], payload.allContacts.total)
        .setIn(['journalists', 'ids'], fromJS([]))
    }

    if (payload.myContacts) {
      newState = newState
        .setIn(['myContacts', 'items'], fromJS(payload.myContacts.contacts))
        .setIn(['myContacts', 'total'], payload.myContacts.total)
        .setIn(['myContacts', 'ids'], fromJS([]))
    } else {
      newState = newState.set('myContacts', initialState.get('myContacts'))
    }

    return newState
  },
  [combineActions(
    Actions.importJournalistsSuccess,
    Actions.importJournalistsToListSuccess
  )]: (state, { payload }) => {
    const normalizedContacts = payload.contacts.reduce((acc, contact) => {
      const existingContact = acc.find(c => c.id === contact.id)

      if (!existingContact) {
        const nextContact = {
          ...contact,
          identities: [contact.identity]
        }

        delete nextContact.identity

        acc.push(nextContact)
      } else {
        existingContact.identities.push(contact.identity)
      }

      return acc
    }, [])

    const contacts = fromJS(normalizedContacts)
    const contactIdentityIds = contacts.flatMap(c => c.get('identities')).map(i => i.get('id'))

    const oldContacts = state.getIn(['myContacts', 'items'])
    const newContacts = oldContacts.map(
      c => {
        const match = contacts.find(nc => nc.get('id') === c.get('id'))

        if (!match) {
          return c
        }

        return c.update('identities', identities => identities.concat(match.get('identities').filter(i => !identities.find(
          j => j.get('id') === i.get('id')
        ))))
      }
    ).concat(contacts.filter(c => !oldContacts.find(oc => oc.get('id') === c.get('id'))))

    const newJournalists = state.getIn(['journalists', 'items'])
      .map(j => j.update('identities', identities => identities.filterNot(i => contactIdentityIds.includes(i.get('id')))))
      .filterNot(j => j.get('identities').isEmpty())

    const diffJournalists = state.getIn(['journalists', 'items']).size - newJournalists.size
    const diffContacts = state.getIn(['myContacts', 'items']).size - newContacts.size

    return state
      .setIn(['journalists', 'items'], newJournalists)
      .setIn(['myContacts', 'items'], newContacts)
      .setIn(['journalists', 'total'], state.getIn(['journalists', 'total']) - diffJournalists)
      .setIn(['myContacts', 'total'], state.getIn(['myContacts', 'total']) - diffContacts)
  },

  [combineActions(
    Actions.findNewsError,
    Actions.findNewsStart
  )]: state => state
    .setIn(['news', 'items'], fromJS([]))
    .setIn(['news', 'total'], 0),

  [Actions.findNewsSuccess]: (state, { payload }) => state
    .setIn(['news', 'items'], fromJS(payload.results))
    .setIn(['news', 'total'], payload.total),

  [Actions.fetchPublicationsSuccess]: (state, { payload }) => (
    state.set('publications', fromJS(payload))
  ),
  [Actions.setFilter]: (state, { payload }) => {
    const { key, value } = payload
    const immutableValue = isImmutable(value) ? value : fromJS(value)

    if ((key === 'channels' || key === 'mediaTypes') && !immutableValue.isEmpty()) {
      return state.set('publications', fromJS([]))
    }

    return state
  },

  [AppActions.resetState]: () => initialState
}, initialState)
